<template>
    <div class="poster-text" :class="[textStyle,mapSize,mapLayout,$root.env]">
        <div class="main" :class="[textStyle,mapSize,mapLayout,$root.env]">
          <TxContent :content="mainText"></TxContent>
        </div>
        <div class="secondary" :class="[textStyle,mapSize,mapLayout,$root.env]">
          <TxContent :content="authorText"></TxContent>
        </div>
    </div>
</template>

<script>
    import PosterTextModule from '../store-mixin'

    export default {
        name: 'PosterText',
        mixins: [PosterTextModule()],
    }
</script>

<style lang="scss">

    //Dont forget to add or change fonts in shopkeeper-child/include/textArtProducts/assets/fonts

    //style 1
    @font-face {
        font-family: 'Montserrat B';
        src: url('../assets/fonts/Montserrat-Bold.eot');
        src: url('../assets/fonts/Montserrat-Bold.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/Montserrat-Bold.woff2') format('woff2'),
        url('../assets/fonts/Montserrat-Bold.woff') format('woff'),
        url('../assets/fonts/Montserrat-Bold.ttf') format('truetype'),
        url('../assets/fonts/Montserrat-Bold.svg#Montserrat-Bold') format('svg');
        font-weight: bold;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Montserrat T';
        src: url('../assets/fonts/style-1/Montserrat-Thin.eot');
        src: url('../assets/fonts/style-1/Montserrat-Thin.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/style-1/Montserrat-Thin.woff2') format('woff2'),
        url('../assets/fonts/style-1/Montserrat-Thin.woff') format('woff'),
        url('../assets/fonts/style-1/Montserrat-Thin.ttf') format('truetype'),
        url('../assets/fonts/style-1/Montserrat-Thin.svg#Montserrat-Thin') format('svg');
        font-weight: 100;
        font-style: normal;
        font-display: swap;
    }

    //style2
    @font-face {
        font-family: 'SF Slapstick Comic Shaded';
        src: url('../assets/fonts/style-2/SFSlapstickComicShaded-Oblique.eot');
        src: url('../assets/fonts/style-2/SFSlapstickComicShaded-Oblique.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/style-2/SFSlapstickComicShaded-Oblique.woff2') format('woff2'),
        url('../assets/fonts/style-2/SFSlapstickComicShaded-Oblique.woff') format('woff'),
        url('../assets/fonts/style-2/SFSlapstickComicShaded-Oblique.ttf') format('truetype'),
        url('../assets/fonts/style-2/SFSlapstickComicShaded-Oblique.svg#SFSlapstickComicShaded-Oblique') format('svg');
        font-weight: normal;
        font-style: italic;
        font-display: swap;
    }


    //style 3
    @font-face {
        font-family: 'Aku and Kamu';
        src: url('../assets/fonts/style-3/AkuKamu.eot');
        src: url('../assets/fonts/style-3/AkuKamu.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/style-3/AkuKamu.woff2') format('woff2'),
        url('../assets/fonts/style-3/AkuKamu.woff') format('woff'),
        url('../assets/fonts/style-3/AkuKamu.ttf') format('truetype'),
        url('../assets/fonts/style-3/AkuKamu.svg#Aku&Kamu') format('svg');
        font-weight: normal;
        font-style: italic;
        font-display: swap;
    }

    //style 4
    @font-face {
        font-family: 'Biloxi Script';
        src: url('../assets/fonts/style-4/BiloxiScript.eot');
        src: url('../assets/fonts/style-4/BiloxiScript.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/style-4/BiloxiScript.woff2') format('woff2'),
        url('../assets/fonts/style-4/BiloxiScript.woff') format('woff'),
        url('../assets/fonts/style-4/BiloxiScript.ttf') format('truetype'),
        url('../assets/fonts/style-4/BiloxiScript.svg#BiloxiScript') format('svg');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Montserrat ExtraLight';
        src: url('../assets/fonts/style-4/Montserrat-ExtraLight.eot');
        src: url('../assets/fonts/style-4/Montserrat-ExtraLight.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/style-4/Montserrat-ExtraLight.woff2') format('woff2'),
        url('../assets/fonts/style-4/Montserrat-ExtraLight.woff') format('woff'),
        url('../assets/fonts/style-4/Montserrat-ExtraLight.ttf') format('truetype'),
        url('../assets/fonts/style-4/Montserrat-ExtraLight.svg#Montserrat-ExtraLight') format('svg');
        font-weight: 200;
        font-style: normal;
        font-display: swap;
    }

    //style 5
    @font-face {
        font-family: 'Amatic SC';
        src: url('../assets/fonts/style-5/AmaticSC-Regular.eot');
        src: url('../assets/fonts/style-5/AmaticSC-Regular.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/style-5/AmaticSC-Regular.woff2') format('woff2'),
        url('../assets/fonts/style-5/AmaticSC-Regular.woff') format('woff'),
        url('../assets/fonts/style-5/AmaticSC-Regular.ttf') format('truetype'),
        url('../assets/fonts/style-5/AmaticSC-Regular.svg#AmaticSC-Regular') format('svg');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    //style 6
    @font-face {
        font-family: 'Bebas Neue Book';
        src: url('../assets/fonts/style-6/BebasNeueBook.eot');
        src: url('../assets/fonts/style-6/BebasNeueBook.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/style-6/BebasNeueBook.woff2') format('woff2'),
        url('../assets/fonts/style-6/BebasNeueBook.woff') format('woff'),
        url('../assets/fonts/style-6/BebasNeueBook.ttf') format('truetype'),
        url('../assets/fonts/style-6/BebasNeueBook.svg#BebasNeueBook') format('svg');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Bebas Neue';
        src: url('../assets/fonts/style-6/BebasNeueBold.eot');
        src: url('../assets/fonts/style-6/BebasNeueBold.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/style-6/BebasNeueBold.woff2') format('woff2'),
        url('../assets/fonts/style-6/BebasNeueBold.woff') format('woff'),
        url('../assets/fonts/style-6/BebasNeueBold.ttf') format('truetype'),
        url('../assets/fonts/style-6/BebasNeueBold.svg#BebasNeueBold') format('svg');
        font-weight: bold;
        font-style: normal;
        font-display: swap;
    }
</style>

<style lang="scss" scoped>
    .poster-text {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;

        ::v-deep * {
            color: black;
            font-size: 72px;
            font-family: unset;
            margin: 0;
        }

        ::v-deep .emoji {
          vertical-align: unset;
          margin: auto!important;
        }


        &.style-1 {
            .main {
                margin: 43px;

                ::v-deep * {
                    font-family: Montserrat T;
                    font-size: 52px;
                    line-height: 1.94em;
                    margin: 0;
                }
                ::v-deep .emoji {
                  height: 39px;
                  width: 39px;
                }
            }

            .secondary {
                ::v-deep * {
                    font-family: Montserrat B;
                    font-size: 20px;
                    font-weight: bold;
                    letter-spacing: -1.1px;
                }
                ::v-deep .emoji {
                  height: 20px;
                  width: 20px;
                  vertical-align: middle;
                }
            }
        }

        &.style-2 {
            .main {
                padding-top: 14px;

                ::v-deep * {
                    font-family: SF Slapstick Comic Shaded;
                    font-size: 72px;
                    margin: 0;
                    line-height: 100px;
                    letter-spacing: 1px;
                }
                ::v-deep .emoji {
                  height: 72px;
                  width: 72px;
                  vertical-align: sub;
                }
            }

            .secondary {
                margin: 10px;

                ::v-deep * {
                    font-family: Montserrat B;
                    font-size: 27px;
                    font-weight: bold;
                    letter-spacing: -0.3px;
                }

                ::v-deep .emoji {
                  height: 27px;
                  width: 27px;
                  vertical-align: middle;
                }
            }
        }

        &.style-3 {
            .main {
                padding-top: 110px;
                margin: -40px;

                ::v-deep * {
                    font-family: Aku and Kamu;
                    font-size: 72px;
                    margin: 0;
                    line-height: 101px;
                    letter-spacing: 1px;
                }

                ::v-deep .emoji {
                  height: 72px;
                  width: 72px;
                  vertical-align: middle;
                }
            }

            .secondary {
                margin: 10px;

                ::v-deep * {
                    font-family: Montserrat B;
                    font-size: 27px;
                    font-weight: bold;
                    letter-spacing: -0.3px;
                }

                ::v-deep .emoji {
                  height: 27px;
                  width: 27px;
                  vertical-align: middle;
                }
            }
        }

        &.style-4 {
            .main {
                margin: -26px;
                padding-top: 62px;


                ::v-deep * {
                    font-family: Biloxi Script;
                    font-size: 71px;
                    line-height: 89px;
                    margin: 0;
                    letter-spacing: 0.9px;
                }

                ::v-deep .emoji {
                  height: 71px;
                  width: 71px;
                  vertical-align: sub;
                }
            }

            .secondary {
                margin: 10px;

                ::v-deep * {
                    font-family: Montserrat ExtraLight;
                    font-size: 20px;
                    letter-spacing: -0.2px;
                }

                ::v-deep .emoji {
                  height: 20px;
                  width: 20px;
                  vertical-align: middle;
                }
            }
        }

        &.style-5 {
            .main {
                padding-top: 115px;
                margin: -40px;

                ::v-deep * {
                    margin: 0;
                    font-family: Amatic SC;
                    font-size: 85px;
                    letter-spacing: 3.4px;
                    line-height: 111px;
                }

                ::v-deep .emoji {
                  height: 74px;
                  width: 74px;
                }
            }

            .secondary {
                margin: 10px;

                ::v-deep * {
                    font-family: Aku and Kamu;
                    font-size: 27px;
                    letter-spacing: -0.4px;
                }

                ::v-deep .emoji {
                  height: 27px;
                  width: 27px;
                  vertical-align: middle;
                }
            }
        }

        &.style-6 {
            .main {
                margin: 94px 0px -74px 0px;

                ::v-deep * {
                    font-family: Bebas Neue;
                    font-size: 126px;
                    margin: 0;
                    line-height: 140px;
                }

                ::v-deep .emoji {
                  height: 100px;
                  width: 100px;
                }
            }

            .secondary {
                margin: 10px;

                ::v-deep * {
                    font-family: Bebas Neue Book;
                    font-size: 40px;
                    letter-spacing: -0.4px;
                }

                ::v-deep .emoji {
                  height: 40px;
                  width: 40px;
                  vertical-align: middle;
                }
            }
        }

    }
</style>

